import { types } from "../../types/types";

export const changeStepper = (step) => async (dispatch) => {
  dispatch({
    type:types.changeStepper,
    payload:step
  })
};

